module.exports = __webpack_public_path__ + "static/media/02C.e4529816.png";